import { render, staticRenderFns } from "./mails-list.vue?vue&type=template&id=63896aae&"
import script from "./mails-list.vue?vue&type=script&lang=js&"
export * from "./mails-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports